import { useContext } from 'react';
import { UserContext } from '../User.context';
import { RoleType } from 'api/api';

export const useRoles = () => {
    const { roles } = useContext(UserContext);
    return roles;
};

export const useHasRole = (role: RoleType) => {
    const roles = useRoles();
    return roles.includes(role);
};

export const useMainRole = () => {
    const roles = useRoles();
    return roles[0];
};

export const useIsAdmin = () => {
    const isAdmin = useHasRole(RoleType.HighOperator);
    return isAdmin;
};
